import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslationApp } from "../../../lib/i18next";
import {
  CAMPAIGN_APPROVAL_ADS_COUNT,
  CAMPAIGN_APPROVAL_ADS_COUNT_SINGLE,
  CAMPAIGN_APPROVAL_AD_SET_LABEL,
} from "../../../i18n/keysTranslations";
import { formatApprovalCountLabel } from "../utils";
import AdAccordion from "./AdAccordion";

const AdGroupSection = ({
  token = "",
  campaignID = "",
  adGroupName,
  entities = [],
  comments = [],
  currentDraftID = "",
  commentsLocked = false,
  isSubmittingComment = false,
  onSubmitSpecificComment,
}) => {
  const { t } = useTranslationApp();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          flexWrap: "wrap",
        }}
      >
        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
            fontWeight: 700,
            letterSpacing: "0.08em",
          }}
        >
          {t(CAMPAIGN_APPROVAL_AD_SET_LABEL)}
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {adGroupName}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            px: 1,
            py: 0.35,
            borderRadius: 10,
            bgcolor: "action.hover",
            color: "text.secondary",
            fontWeight: 600,
          }}
        >
          {formatApprovalCountLabel(
            entities.length,
            CAMPAIGN_APPROVAL_ADS_COUNT,
            CAMPAIGN_APPROVAL_ADS_COUNT_SINGLE,
            t
          )}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
        {entities.map((entity) => (
          <AdAccordion
            key={`${entity.entityType}-${entity.entityID}`}
            token={token}
            campaignID={campaignID}
            entity={entity}
            comments={comments}
            currentDraftID={currentDraftID}
            commentsLocked={commentsLocked}
            isSubmittingComment={isSubmittingComment}
            onSubmitSpecificComment={onSubmitSpecificComment}
          />
        ))}
      </Box>
    </Box>
  );
};

export default AdGroupSection;
